import React from 'react';
import { Message } from '@nakedplatform/ui';

/**
 * Renders a list of messages with logic to handle showing the chat bubble tip
 *
 * @param props - Props passed to this component
 */
export function MessageList(props: MessageListProps) {
  const { messages } = props;

  return (
    <>
      {messages.map((message, i) => (
        <Message key={i} text={message} showTip={i === 0} />
      ))}
    </>
  );
}
interface MessageListProps {
  messages: string[];
}
